module.exports = __webpack_public_path__ + "static/stories2-77f3e246ea390e663beb9724f58c47db.png";